import React from "react";
import { UserData } from "../../types/responseTypes";
import { useLocation } from "react-router-dom";

import {
  EditUserNameForm,
  EditUserPhoneForm,
  EditUserEmailForm,
} from "../../styles/forms";
import { EditUserBanner } from "../../styles/banners";

import editUserName from "./editUserName";
import editUserPhone from "./editUserPhone";
import editUserEmail from "./editUserEmail";

const EditUserData: React.FC = () => {
  const location = useLocation();
  const { userData, bookingIndex } = location.state as {
    userData: UserData;
    bookingIndex: number;
  };
  console.log("Edit User Data", userData);

  return (
    <div>
      <EditUserBanner userData={userData} backLink="/home" bookingIndex={bookingIndex} />
      <div className="flex flex-col items-center justify-center mt-10 md:mt-20">
        {/* <EditUserNameForm
          userData={userData}
          editUserName={(newFirstName: string, newLastName: string) => {
            editUserName(newFirstName, newLastName);
          }}
        /> */}
        <EditUserPhoneForm
          userData={userData}
          editUserPhone={(newPhone: string) => {
            return editUserPhone(newPhone);
          }}
          bookingIndex={bookingIndex}
        />
        <EditUserEmailForm
          userData={userData}
          editUserEmail={(newEmail: string) => {
            return editUserEmail(newEmail);
          }}
          bookingIndex={bookingIndex}
        />
      </div>
    </div>
  );
};

export default EditUserData;
